import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { Trophy } from 'lucide-react';

/**
 * Standalone Valuables Inventory tool.
 * List high-value items for insurance documentation; export to add to your binder.
 */
const ValuablesTool = () => {
  return (
    <ToolLayout
      title="Valuables Inventory"
      description="List your valuable items so you have a record for insurance if something happens."
      icon={Trophy}
      guide={{
        intro: 'Keep a list of your valuable items so you can file insurance claims after a disaster.',
        steps: [
          'Add items with a name, category, and what you think they\'re worth.',
          'Note where each item is or add a photo.',
          'Save for your binder.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          List your valuable items with what they're worth and where they are. This helps with insurance claims if something happens.
        </p>
        <p className="text-sm text-muted-foreground">
          Full valuables list and Save coming soon.
        </p>
      </div>
    </ToolLayout>
  );
};

export default ValuablesTool;
